import Flux from 'lib/flux';

const NavigationConstants = Flux.createConstants({
  serviceMessages: ['TRANSITION_TO', 'TRANSITION_BACK'],
});

export default NavigationConstants;
